module.exports = __webpack_public_path__ + "static/media/Home GIF.396257a5.gif";